import React, { Component } from "react";
import { View, Text, StyleSheet, Dimensions } from "react-native";

import BackgroundImage from "components/BackgroundImage";
import * as x from "styles/css";

class ViewScroll extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		};

		this.handleLayout = this.handleLayout.bind(this);
	}

	componentDidMount() {
		this.setState({
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		});
	}

	handleLayout(evt) {
		this.setState({
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		});
	}

	render() {
		return (
			<View
				style={[{ height: "100%" }, this.props.style]}
				onLayout={this.handleLayout}
			>
				<View
					style={[
						this.state.width <= 600
							? styles.mobile
							: styles.scrollView,
						this.state.width <= 600 ? {} : x.m.auto,
					]}
					{...this.props}
				>
					{this.props.children}
				</View>
			</View>
		);
	}
}

const styles = StyleSheet.create({
	scrollView: {
		padding: 20,
		width: 800,
		minHeight: 800,
		backgroundColor: "white",
	},
	mobile: {
		flex: 1,
		backgroundColor: "white",
		padding: 30,
		minHeight: "100vh",
	},
});

export default ViewScroll;



// WEBPACK FOOTER //
// ./src/components/ViewScroll/index.web.js